import React from "react";
import phone from "../../images/Global/Nav/phone.svg";

const UtilityNav = ({ navigationStyle, pageType }) => {
  return (
    pageType !== "Landing" && (
      <div
        id="utlity-navigation"
        className={`hidden bg-black py-1.5 lg:block ${
          navigationStyle === "overlap" ? "" : ""
        }`}
      >
        <div className="container">
          <div className="flex items-center justify-between">
            <div>
              <a
                href="tel:323-910-1070"
                className="flex items-center font-heading text-sm font-normal text-white no-underline hover:text-white"
              >
                <img src={phone} alt="Phone" className="mr-2" />
                (323) 910-1070
              </a>
            </div>
            <div className="flex items-center space-x-6">
            <div>
                <a
                  href="/mortgage-calculators/"
                  target="_blank"
                  rel="noreferrer"
                  className="font-heading text-sm font-normal text-white no-underline hover:text-white"
                >
                  Mortgage Calculators
                </a>
              </div>
              <div>
                <a
                  href="https://markdarling.floify.com/login"
                  target="_blank"
                  rel="noreferrer"
                  className="font-heading text-sm font-normal text-white no-underline hover:text-white"
                >
                  Login
                </a>
              </div>
              <div>
                <a
                  href="https://markdarling.floify.com/apply-now"
                  target="_blank"
                  rel="noreferrer"
                  className="font-heading text-sm font-normal text-white no-underline hover:text-white"
                >
                  Apply Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};
export default UtilityNav;
